export default "__VITE_ASSET__68b32e61__"